module.exports = __webpack_public_path__ + "media/icons/support-c7af4840.png";